export default __webpack_public_path__ + "static/media/TalonSample.f33d224c.png";